import moment, {Moment} from 'moment'
import dayjs, {Dayjs} from 'dayjs'

export const isPast = (currentDate: Moment | Dayjs) => {
    if ('valueOf' in currentDate && typeof currentDate.valueOf === 'function') {
        return currentDate.valueOf() < moment().valueOf()
    }
    return false
}

export const isDateBefore = (currentDate: Moment | Dayjs) => {
    if (dayjs.isDayjs(currentDate)) {
        return currentDate.isBefore(dayjs(), 'day')
    }
    return moment(currentDate).isBefore(moment(), 'day')
}
